import { createFileRoute } from "@tanstack/react-router";

import { TrainingPlanBuilder } from "@/features/training-plans/modules/training-plan-builder/training-plan-builder";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/trainees/$clientId/training-plans/$planId")({
  loader: () => ({ crumb: m.training_plan_crumb() }),
  component: RouteComponent,
});

function RouteComponent() {
  const { clientId, planId } = Route.useParams();
  return <TrainingPlanBuilder clientId={clientId} planId={planId} />;
}
